"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function cov_1oybnbitp3() {
  var path = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/ThemeMapper/lib/defaultTheme.js";
  var hash = "f520c3df25ae652bacfffe3e397bae592cafae9d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/ThemeMapper/lib/defaultTheme.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f520c3df25ae652bacfffe3e397bae592cafae9d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1oybnbitp3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1oybnbitp3();
// list of possible values. It is only used as reference to create the proper object per iteration
var _default = exports.default = {
  bodyBgColor: '#FFFFFF',
  showBgImagesOnMobile: false,
  headerBgColor: '#FFFFFF',
  headerTextColor: '#3B3D40',
  footerBgColor: '#FFFFFF',
  footerTextColor: '#626262',
  buttonBgColorTop: '#1a84f1',
  buttonBgColorBottom: '#1a84f1',
  messageTextColor: '#3B3D40',
  messageBgColor: '#FFFFFF',
  messageBgColorTransparent: '0',
  // contentBgColor: '#FFFFFF',
  boxBorderRadius: '8px',
  // mobileRelativeBoxBorderRadius: '5px',
  // buttonBorderRadius: '5px',
  boxTitleMode: 'TRANSPARENT',
  boxTitleBgTop: '#FFFFFF',
  boxTitleBgBottom: '#FFFFFF',
  boxTitleTextColor: 'black',
  boxTitleTextAlign: 'left',
  boxTitleUnderlinePadding: '0',
  altBoxTitleTextAlign: 'left',
  altBoxTitleUnderlinePadding: '2px',
  altBoxTitleBgTop: '#8d8d8d',
  altBoxTitleBgBottom: '#8d8d8d',
  // todo lighten 12%
  altBoxTitleTextColor: '#3B3D40',
  buttonTextColor: 'white',
  secondaryContentFloat: 'right',
  boxBgColor: '#F7F7F7',
  // backgroundColor / main area bg color
  innerBoxBgColor: '#E6E6E6',
  // embededAreaBgColor
  boxTitleTextTransform: 'none',
  boxTitleTextSize: '2em',
  boxTitleTextWeight: '600',
  textColor: '#3B3D40',
  linkTextColor: '#3B3D40',
  productNameTextColor: '#3B3D40',
  mobileMenuBgColor: '#420084',
  mobileMenuTextColor: '#FFA850',
  // headerLogo: "url('logo.png') no-repeat",
  // headerLogoUrl: 'https://special-mosa.int1-shop.secutix.com/light_custom/lightTheme/logo.png',
  // headerLogoWidth: '329px',
  // headerLogoHeight: '100px',
  // headerMobileLogo: "url('dddddlogo.png') no-repeat",
  // headerMobileLogoUrl:
  //   'https://special-mosa.int1-shop.secutix.com/light_custom/lightTheme/dddddlogo.png',
  // headerMobileLogoWidth: '329px',
  advantageColor: '#1a84f1',
  advantageTextColor: 'white',
  hasCustomHeader: false,
  hasCustomFooter: false,
  font: {
    family: 'Arial',
    provider: 'SYSTEM',
    isGlobal: true
  },
  hasCustomFont: true
};